(function () {
    'use strict';

    angular
        .module('iqxCore')
        .controller('ClientCurrentRequirementsAddShiftsCtrl', ClientCurrentRequirementsAddShiftsCtrl)

    function ClientCurrentRequirementsAddShiftsCtrl($scope, ApiSvc, FormSvc, toastSvc, $location) {
        var addShifts = this
        addShifts.addShiftsRes = {} // empty object for fetch to use
        addShifts.requirements = []
        addShifts.orderReasons = []
        addShifts.shifts = []
        addShifts.addedShifts = []
        addShifts.requirementSelected = requirementSelected
        addShifts.templateSelected = templateSelected
        addShifts.add = add
        addShifts.addRow = addRow
        addShifts.duplicate = duplicate
        addShifts.remove = remove
        addShifts.submit = submit
        addShifts.viewAddedShift = viewAddedShift
        addShifts.checkShiftValid = checkShiftValid
        addShifts.back = back

        activate()

        //

        function activate() {
            getRequirements().then(getOrderReasons)
        }

        function add() {
            addShifts.shifts.push({ qty: 1 })
            sort()
        }

        function addRow() {
            $scope.formData = { qty: 1 }
            FormSvc.modalForm($scope, 'addShift', $scope.formData, 'md', { label: 'col-sm-2', data: 'col-sm-10' })
                .then(function (d) {
                    addShifts.shifts.push($scope.formData)
                    sort()
                })
        }

        function duplicate(shift, dayDiff) {
            var newShift = angular.copy(shift)
            newShift.date.add((dayDiff || 0), 'days')
            addShifts.shifts.push(newShift)
            sort()
        }

        function remove(index) {
            addShifts.shifts.splice(index, 1)
        }

        function sort() {
            addShifts.shifts.sort(function (a, b) {
                if (!a.date || !b.date || a.date.isSame(b.date, 'day')) {
                    return 0
                }
                if (a.date.isBefore(b.date)) {
                    return -1
                }
                return 1
            })
        }

        function submit() {
            var error = checkBeforeSubmit()
            if (error) {
                FormSvc.alert(error[0], error[1], "error")
                return false
            }

            var sendString = ''

            angular.forEach(addShifts.shifts, function (val, key) {
                val.requirement = addShifts.selectedRequirement // add vacancy obj to shift, to be used in 'added this session table'
                val.reference = addShifts.reference // add vacancy obj to shift, to be used in 'added this session table'
                val.reason = addShifts.reason.value // add vacancy obj to shift, to be used in 'added this session table'

                sendString += addShifts.selectedRequirement.VacancyID + '|' +
                    val.type + '|' +
                    encodeURIComponent(val.date.format("YYYY-MM-DD")) + '|' +
                    encodeURIComponent(moment(val.from).format("HH:mm")) + '|' +
                    encodeURIComponent(moment(val.to).format("HH:mm")) + '|' +
                    (val.qty || 1) + '|' +
                    addShifts.reason.value + '|' +
                    encodeURIComponent(addShifts.reference) + '|' +
                    (val.note ? encodeURIComponent(val.note) : '') + '|' +
                    val.break + '*'
            })
            sendString = sendString.slice(0, -1) // remove last star at end of string

            return ApiSvc.fetch(
                addShifts.addShiftsRes,
                {
                    fetchAPI: 'call/NetClientAddMultipleShifts?pParamList=' + sendString,
                    fetchTarget: 'insertShift',
                    multiRow: false
                }
            ).then(submitSuccess)
        }

        function checkBeforeSubmit() {
            if (!addShifts.selectedRequirement) { return ["Missing requirement", "Please ensure that you have selected a requirement."] }
            var errors = []
            angular.forEach(addShifts.shifts, function (val, key) {
                var error = checkShiftValid(val)
                if (error !== null) {
                    errors.push(error)
                }
            })
            if (errors.length > 0) { return errors[0] } // return the first error if any where found in shifts
            if (!addShifts.reference) { return ["Missing reference", "Please ensure that you have selected a reference."] }
            if (!addShifts.reason) { ["Missing reason", "Please ensure that you have selected a reason."] }
            return null
        }

        function checkShiftValid(shift) {
            if (!shift.date || !moment.isMoment(shift.date)) { return ["Missing date", "Please ensure that all shifts have a date."] }
            if (!shift.type) { return ["Missing type", "Please ensure that all shifts have a type."] }
            if (!shift.from) { return ["Missing time", "Please ensure that all shifts have a start time."] }
            if (!shift.to) { return ["Missing time", "Please ensure that all shifts have a finish time."] }
            if (!isFinite(shift.break) || shift.break < 0) { return ["Missing break", "Please ensure that all shifts have a break (minutes)."] }
            if (!shift.qty) { return ["Missing quantity", "Please ensure that all shifts have a quantity."] }
            return null
        }

        function submitSuccess() {
            toastSvc.success(
                (addShifts.shifts.length === 1 ? "Shift" : "Shifts") + " Added",
                (addShifts.shifts.length === 1 ? "Shift" : "Shifts") + " added successfully."
            )

            // move all elements from shifts array to addedShifts array
            while (addShifts.shifts.length > 0) {
                addShifts.addedShifts.push(addShifts.shifts.shift())
            }
            add() // add empty row to the table as it will now be empty
            addShifts.reference = "" // clear refrence input
            addShifts.reason = {} // clear reason select
        }

        function getRequirements() {
            return ApiSvc.fetch(
                addShifts,
                {
                    fetchAPI: 'callresult/NetClientCombinedRequirementTemplates',
                    fetchTarget: 'requirements',
                    multiRow: true
                }
            )
        }

        function getOrderReasons() {
            return ApiSvc.fetch(
                addShifts,
                {
                    fetchAPI: 'callresult/NetClientShiftOrderReasons',
                    fetchTarget: 'orderReasons',
                    multiRow: true
                }
            )
        }

        function requirementSelected() {
            return ApiSvc.fetch(
                addShifts,
                {
                    fetchAPI: 'callresult/NetClientShiftDetailsTemplates?pVacancyID=' + addShifts.selectedRequirement.VacancyID,
                    fetchTarget: 'shiftTemplates',
                    multiRow: true,
                    timeFields: ['TimeFrom', 'TimeTo'],
                    numberFields: ['BreakMinutes', 'SortOrder'],
                    booleanFields: ['Moveable']
                }
            )
        }

        function templateSelected(shift) {
            shift.from = shift.formData.template.TimeFrom
            shift.to = shift.formData.template.TimeTo
            shift.break = shift.formData.template.BreakMinutes
            shift.type = shift.formData.template.LineID
        }

        function viewAddedShift(shift) {
            var data = { choices: [{ desc: 'Close', type: 'primary', code: '' }], shift: shift }
            var modelName = "viewAddedShift"
            FormSvc.modalInfo($scope, modelName, data, 'md')
        }

        function back() {
            $location.path("/currentrequirements")
        }

    } // endOf function ClientCurrentRequirementsAddShiftsCtrl
})()